import { Alert } from '@/shared/ui/Alert';
import { Button } from '@/shared/ui/Button';

import { useInstallPrompt } from './useInstallPrompt';

/**
 * Convite para instalar a aplicacao.
 *
 * O componente nao renderiza nada quando a instalacao nao esta disponivel ou
 * quando o aplicativo ja esta instalado. Um botao permanentemente inerte seria
 * pior do que a ausencia do botao.
 */
export function InstallAppCard({ appName = 'SeguraCore' }: { appName?: string }) {
  const { state, canInstall, promptInstall } = useInstallPrompt();

  if (state === 'installed') {
    return null;
  }

  if (!canInstall) {
    return null;
  }

  return (
    <div className="surface-card flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <span className="brand-gradient mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-lg text-white">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M12 3v12" />
            <path d="m7.5 10.5 4.5 4.5 4.5-4.5" />
            <path d="M4.5 17v2.5a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5V17" />
          </svg>
        </span>
        <div>
          <p className="text-sm font-semibold text-ink-900">
            Instalar {appName} neste dispositivo
          </p>
          <p className="mt-0.5 text-xs text-ink-500">
            Acesso direto, abertura em janela propria e inicio mais rapido.
          </p>
        </div>
      </div>

      <Button
        onClick={() => {
          void promptInstall();
        }}
      >
        Instalar aplicativo
      </Button>
    </div>
  );
}

/** Aviso usado quando a instalacao foi recusada e o usuario quer tentar de novo. */
export function InstallDismissedHint() {
  const { state } = useInstallPrompt();

  if (state !== 'dismissed') {
    return null;
  }

  return (
    <Alert tone="info" title="Instalacao adiada">
      Voce pode instalar mais tarde pelo menu do navegador, na opcao de instalar ou
      adicionar a tela inicial.
    </Alert>
  );
}
